import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { WorkistLogo } from '../../core/components/WorkistLogo.tsx';

interface Props {
    referenceNumber: string;
    tenantName?: string;
}

const ThankYouPage = ({ referenceNumber, tenantName }: Props) => {
    const { t } = useTranslation('forms');
    return (
        <div className="h-full bg-surface-medium text-content-strong flex items-center justify-center overflow-y-auto">
            <div className="max-w-md text-center p-10 bg-surface-weak border border-solid border-line-weak rounded">
                <h1 className="text-2xl font-semibold mb-3">{t('thankYou.title')}</h1>
                <p className="text-content-medium mb-6">
                    {tenantName ? t('thankYou.bodyWithTenant', { tenant: tenantName }) : t('thankYou.body')}
                </p>
                <div className="bg-surface-medium border border-solid border-line-weak rounded p-3 mb-6 inline-block">
                    <div className="text-xs text-content-medium mb-1">{t('thankYou.reference')}</div>
                    <div className="font-mono text-sm select-all">{referenceNumber}</div>
                </div>
                <div className="text-xs text-content-medium flex items-center gap-2 justify-center">
                    <span>{t('poweredBy')}</span>
                    <a href="https://workist.com" target="_blank" rel="noopener noreferrer">
                        <WorkistLogo className="h-4 w-auto" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ThankYouPage;
